// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vyKrfuYsj1sCwSZfip5H {
  height: 40px;
  font-size: 12px !important;
  border: none !important;
  border-radius: 12px;
}

.p4UgZYOiu6uPy4cnCXrp {
  padding: 10px;
  font-size: 12px !important;
  border: none !important;
  border-radius: 12px;
}`, "",{"version":3,"sources":["webpack://./js/view/component/form-items/styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".form_input {\n  height: 40px;\n  font-size: 12px !important;\n  border: none !important;\n  border-radius: 12px;\n}\n\n.form_textarea {\n  padding: 10px;\n  font-size: 12px !important;\n  border: none !important;\n  border-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form_input": `vyKrfuYsj1sCwSZfip5H`,
	"form_textarea": `p4UgZYOiu6uPy4cnCXrp`
};
export default ___CSS_LOADER_EXPORT___;
